import React, {useEffect, useRef, useState} from 'react'
import axios from 'axios'
import moment from 'moment'
import Cookies from 'js-cookie'
import * as constants from 'constants/index.js'
import notify from '@utils/notify';
import { fetchTrackingDevices } from '@pages/tracking/api/devicesApi';

import CardsHeader from 'layouts/Headers/CardsHeader.js'
import InputCustom from 'views/pages/components/InputCustom'

import {Card, CardBody, CardHeader, Col, Container, Row,} from 'reactstrap'

export default function GeneralOverview() {

  const [token, setToken] = useState('')
  const [items, setItems] = useState([])
  const [selectedDeviceId, setSelectedDeviceId] = useState('')
  const [selectedDate, setSelectedDate] = useState({
    from: moment().format('YYYY-MM-DDT00:00:00'),
    to: moment().format('YYYY-MM-DDT23:59:59')
  })

  useEffect(() => {

    window.addEventListener('message', function (event) {
      if (typeof event.data === 'string' && event.data.indexOf('MapView|') === 0) {
        console.log(event.data)
      }
    })

    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const controller = new AbortController();

    (async () => {
      try {
        const itemsFetched = await fetchTrackingDevices({ token: grs_token, signal: controller.signal });
        setItems(itemsFetched);
        // replicate marker logic
        if (itemsFetched.length > 0) {
          let markers = '';
          let i = 0;
          itemsFetched.forEach((item, index) => {
            if (item.location) {
              if (i === 0) {
                markers += `"markername${index}": { "title": "${item.name}", "appendpoints": [[${item.location.latitude}, ${item.location.longitude}]], "label": "${item.name}", "color": "#f0f" }`;
              } else {
                markers += `, "markername${index}": { "title": "${item.name}", "appendpoints": [[${item.location.latitude}, ${item.location.longitude}]], "label": "${item.name}", "color": "#f0f" }`;
              }
              i++;
            }
          });
          const namedmarkers = JSON.parse(`{ ${markers} }`);
          const cmd = JSON.stringify({ clear: 'all', ruler: true, namedmarkers });
          if (document.getElementById('map')) {
            document.getElementById('map').contentWindow.postMessage(`MapView|cmd: ${cmd}`, '*');
          }
        }
      } catch (e) {
        if (e.name !== 'AbortError' && e.name !== 'CanceledError') {
          notify.warning(e.response && e.response.data ? e.response.data.message : e.response ? e.response.statusText : 'Error Occurred!')
        }
      }
    })();

    return () => {
      controller.abort()
    }
  }, [])

  useEffect(() => {
    if (items && items.length > 0) {

      window.addEventListener('message', function (event) {
        if (typeof event.data === 'string' && event.data.indexOf('MapView|') === 0) {
          console.log(event.data)

          let markers = ''
          let i = 0
          items.forEach((item, index) => {
            if (item.location) {
              if (i === 0) {
                markers += `"markername${index}": { "title": "${item.name}", "appendpoints": [[${item.location.latitude}, ${item.location.longitude}]], "label": "${item.name}", "color": "#f0f" }`
              } else {
                markers += `, "markername${index}": { "title": "${item.name}", "appendpoints": [[${item.location.latitude}, ${item.location.longitude}]], "label": "${item.name}", "color": "#f0f" }`
              }
              i++
            }
          })
    
          const namedmarkers = JSON.parse(`{ ${markers} }`)
          const cmd = JSON.stringify({ "clear": "all", ruler: true, "namedmarkers": namedmarkers })
          
          if (document.getElementById('map')) {
            document.getElementById('map').contentWindow.postMessage(`MapView|cmd: ${cmd}`, '*')
          }
        }
      })
    }
  }, [items])

  const DeviceItem = ({device}) => {
    return (
      <Row className={`device-item ${device.id === selectedDeviceId ? `selected-device-item` : ``} `} onClick={() => selectDevice(device.id, parseInt(moment(selectedDate.from).format('X')), parseInt(moment(selectedDate.to).format('X')))}>
        <Col md={4} style={{ color: '#FFFFFF', textAlign: 'center' }}>
          <i className="fa fa-microchip" aria-hidden="true"/>
          <div>
            <small>{`# ${device.id}`}</small>
          </div>
        </Col>
        <Col md={8} style={{ color: '#FFFFFF', }}>
          <div>
            {device.name}
          </div>
          <div>
            <small><i className="fa fa-plug" aria-hidden="true"></i> {device.identifier ? device.identifier : `<no ident>`}</small>
          </div>
          <div>
            <small><i className="fa fa-phone" aria-hidden="true"></i> {device.phoneNumber ? device.phoneNumber : `<no phone>`}</small>
          </div>
        </Col>
      </Row>
    )
  }

  const selectDevice = async (deviceId, from_date, to_date) => {
    setSelectedDeviceId(deviceId)

    try {
      const response = await axios({
        method: 'GET',
        url: `${constants.API_URL}/tracking/device/${deviceId}/messages/show`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          from: from_date,
          to: to_date, 
          fields: "timestamp,position.latitude,position.longitude"
        }
      })
      console.log('response :: ', response.data)
      const data = response.data
      const result = data.data.messages.result

      let points = ''
      result.forEach((position, index) => {
        if (position['position.latitude'] && position['position.longitude']) {
          if (index === 0) {
            points += `[${position['position.latitude']},${position['position.longitude']}]`
          } else {
            points += `,[${position['position.latitude']},${position['position.longitude']}]`
          }
        }
      })
      document.getElementById('map').contentWindow.postMessage(`MapView|cmd:{"clear": "all"}`, '*')
      document.getElementById('map').contentWindow.postMessage(`MapView|cmd:{"appendpoints": [${points}]}`, '*')
    } catch (error) {
      console.error('error :: ', error)
      notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
    }
  }

  return (
    <>
      <CardsHeader name="Dashboard Management" parentName="Tracking Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between">
                  <div>
                    <h1 className="title">Tracker Dashboard</h1>
                    <span className="text-sm mb-0">See all tracked vehicles here.</span>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={4} sm={6} className="py-2">
                    <div className="d-flex flex-column align-items-center border border-default py-3">
                      <h2>Vehicles with Trackers</h2>
                      <i className="fas fa-truck" style={{ color: '#db4021', fontSize: '50px', paddingTop: '10px' }}></i>
                      <h2 style={{ paddingTop: '10px' }}>No:</h2>
                    </div>
                  </Col>
                  <Col md={4} sm={6} className="py-2">
                    <div className="d-flex flex-column align-items-center border border-default py-3">
                      <h2>Active Vehicles</h2>
                      <i className="fas fa-check-circle" style={{ color: '#db4021', fontSize: '50px', paddingTop: '10px' }}></i>
                      <h2 style={{ paddingTop: '10px' }}>No:</h2>
                    </div>
                  </Col>
                  <Col md={4} sm={6} className="py-2">
                    <div className="d-flex flex-column align-items-center border border-default py-3">
                      <h2>Imobilised Vehicles</h2>
                      <i className="fas fa-times-circle" style={{ color: '#db4021', fontSize: '50px', paddingTop: '10px' }}></i>
                      <h2 style={{ paddingTop: '10px' }}>No:</h2>
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardBody>
                <h1>Map Displaying all vehicle tracker locations</h1>
                <Row className="mt-3 pl-3">
                  <Col md={3} sm={12} style={{backgroundColor: '#424242'}}>
                    <h2 className="pt-3" style={{ color: '#FFFFFF' }}>{`Devices`}</h2>
                    <Row>
                      <Col md={6} sm={12}>
                        <InputCustom
                          type={`datetime-local`}
                          labelClassName={`white-label`}
                          value={selectedDate && selectedDate.from ? selectedDate.from : ''}
                          max={selectedDate.to}
                          onChange={e => {
                            setSelectedDate({
                              ...selectedDate,
                              from: e.target.value
                            })
                            if (selectedDeviceId) {
                              selectDevice(selectedDeviceId, parseInt(moment(e.target.value).format('X')), parseInt(moment(selectedDate.to).format('X')))
                            }
                          }}
                        />
                      </Col>
                      <Col md={6} sm={12}>
                        <InputCustom
                          type={`datetime-local`}
                          labelClassName={`white-label`}
                          value={selectedDate && selectedDate.to ? selectedDate.to : ''}
                          min={selectedDate.from}
                          onChange={e => {
                            setSelectedDate({
                              ...selectedDate,
                              to: e.target.value
                            })
                            if (selectedDeviceId) {
                              selectDevice(selectedDeviceId, parseInt(moment(selectedDate.from).format('X')), parseInt(moment(e.target.value).format('X')))
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    <div style={{overflowX: 'hidden', overflowY: 'auto', height: 640}}>
                      {items.length > 0 &&
                        items.map((device, index) => {
                          return <DeviceItem device={device} key={index} />
                        })
                      }
                    </div>
                  </Col>
                  <Col md={9} sm={12}>
                    <iframe id="map" src="https://flespi.io/mapview/" width="100%" height="800"></iframe>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}